import Vue from 'vue';

Vue.filter('numFormat', (number) => {
    const formmat = (n = 2, x = 3, s = ' ', c = '.') => {
        const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')'
        const num = (number * 1).toFixed(Math.max(0, ~~n))

        return (c ? num?.replace('.', c) : num)?.replace(
            new RegExp(re, 'g'),
            '$&' + (s || ',')
        )
    }
    let digit = formmat()

    if (digit.includes('.00')) {
        digit = digit?.replace('.00', '')
    }
    return digit
})